// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file repos/v1/repo_layout.proto (package github.repos.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file repos/v1/repo_layout.proto.
 */
export const file_repos_v1_repo_layout: GenFile = /*@__PURE__*/
  fileDesc("ChpyZXBvcy92MS9yZXBvX2xheW91dC5wcm90bxIPZ2l0aHViLnJlcG9zLnYxIo0CCg5SZXBvTGF5b3V0RGF0YRIzCgJqcxgBIAMoCzInLmdpdGh1Yi5yZXBvcy52MS5SZXBvTGF5b3V0RGF0YS5Kc0VudHJ5EjUKA2NzcxgCIAMoCzIoLmdpdGh1Yi5yZXBvcy52MS5SZXBvTGF5b3V0RGF0YS5Dc3NFbnRyeRpGCgdKc0VudHJ5EgsKA2tleRgBIAEoCRIqCgV2YWx1ZRgCIAEoCzIbLmdpdGh1Yi5yZXBvcy52MS5TdHJpbmdMaXN0OgI4ARpHCghDc3NFbnRyeRILCgNrZXkYASABKAkSKgoFdmFsdWUYAiABKAsyGy5naXRodWIucmVwb3MudjEuU3RyaW5nTGlzdDoCOAEiHAoKU3RyaW5nTGlzdBIOCgZ2YWx1ZXMYASADKAliBnByb3RvMw");

/**
 * Fingerprinted URLs of the global `javascript_bundle`/`stylesheet_bundle`s that the repo
 * app's sub-app controllers declare. Delivered in the `repoLayoutRoute` payload so the client
 * can inject a destination route's bundles on a React soft-navigation (they only load on a
 * hard navigation otherwise).
 *
 * @generated from message github.repos.v1.RepoLayoutData
 */
export type RepoLayoutData = Message<"github.repos.v1.RepoLayoutData"> & {
  /**
   * JS bundle name -> fingerprinted script src(s).
   *
   * @generated from field: map<string, github.repos.v1.StringList> js = 1;
   */
  js: { [key: string]: StringList };

  /**
   * CSS bundle name -> fingerprinted stylesheet href(s).
   *
   * @generated from field: map<string, github.repos.v1.StringList> css = 2;
   */
  css: { [key: string]: StringList };
};

/**
 * Describes the message github.repos.v1.RepoLayoutData.
 * Use `create(RepoLayoutDataSchema)` to create a new message.
 */
export const RepoLayoutDataSchema: GenMessage<RepoLayoutData> = /*@__PURE__*/
  messageDesc(file_repos_v1_repo_layout, 0);

/**
 * A list of strings. Needed because proto3 `map` values cannot be `repeated`, and a bundle
 * can expand to several chunk files.
 *
 * @generated from message github.repos.v1.StringList
 */
export type StringList = Message<"github.repos.v1.StringList"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message github.repos.v1.StringList.
 * Use `create(StringListSchema)` to create a new message.
 */
export const StringListSchema: GenMessage<StringList> = /*@__PURE__*/
  messageDesc(file_repos_v1_repo_layout, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(RepoLayoutDataSchema, "63c5018e8653")
registerSchemaHash(StringListSchema, "6b0979d1a19a")
